<!-- 区域看板 -->
<template>
    <div class="screen-content">
        <div class="header">
            <div class="info">
                <div>{{ date | formatDateTime }}</div>
                <div>区域：
                    <el-select v-model="zoneId" popper-append-to-body filterable size="small" @change="zoneChange">
                        <el-option label="未关联区域" value=""></el-option>
                        <el-option v-for="item in zoneList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                 </div>
            </div>
            <div class="title">{{ zoneName ? zoneName : '车回佳' }}发货看板</div>
            <div class="otherdatas">
                <div class="otheritems1">
                    <div class="item1">待备货：{{ data1 }}</div>
                    <div class="item2">待打包：{{ data2 }}</div>
                </div>
                <div class="otheritems2">
                    <div class="item1">待发货：{{ data3 }}</div>
                    <div class="item2">已发货：{{ data4 }}</div>
                </div>
            </div>
        </div>
        <div class="content">
            <el-table
                ref="msgTable"
                :data="tableData"
                style="width: 100%; font-size: 40px"
                :header-cell-style="{ background: '#ee5622' }"
                :row-class-name="tableRowClassName"
                :row-style="{ height: '80px' }"
                :cell-style="{ padding: '0px' }"
                height="882px"
            >
                <el-table-column type="index" width="150px" sortable></el-table-column>
                <el-table-column prop="OrderCode" label="出单号" width="660px" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="CusName" label="客户" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="OperType" label="操作" width="250px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.OperType == '待备货'" class="active1">{{ scope.row.OperType }}</i>
                        <i v-else-if="scope.row.OperType == '待打包'" class="active2">{{ scope.row.OperType }}</i>
                        <i v-else-if="scope.row.OperType == '已开始备货'" class="active3">{{ scope.row.OperType }}</i>
                        <i v-else-if="scope.row.OperType == '已开始打包'" class="active4">{{ scope.row.OperType }}</i>
                        <i v-else-if="scope.row.OperType == '等待发货'" class="active5">{{ scope.row.OperType }}</i>
                        <!-- <i v-else-if="scope.row.OperType == '已发货'" class="active1">{{ scope.row.OperType }}</i> -->
                        <i v-else>{{ scope.row.OperType }}</i>
                    </template></el-table-column
                >
                <el-table-column prop="Operater" label="操作人" width="180px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.OperType == '待备货'" class="active1">{{ scope.row.Operater }}</i>
                        <i v-else-if="scope.row.OperType == '待打包'" class="active2">{{ scope.row.Operater }}</i>
                        <i v-else-if="scope.row.OperType == '已开始备货'" class="active3">{{ scope.row.Operater }}</i>
                        <i v-else-if="scope.row.OperType == '已开始打包'" class="active4">{{ scope.row.Operater }}</i>
                        <i v-else-if="scope.row.OperType == '等待发货'" class="active5">{{ scope.row.Operater }}</i>
                        <!-- <i v-else-if="scope.row.OperType == '已发货'" class="active1">{{ scope.row.OperType }}</i> -->
                        <i v-else>{{ scope.row.Operater }}</i>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <audio ref="audio" controls hidden></audio>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import { setInterval, clearTimeout } from 'timers';
export default {
    mixins: [mixin],
    name: '',
    components: {},
    data() {
        return {
            timer: null,
            timeOut: null,
            tableData: [],
            userInfo: this.$util.getLocalStorage('userMsg'),
            newOrderAudio: '/download/neworder.mp3',
            // round: 0,
            currentTime: null,
            date: new Date(),
            zoneId: '',
            zoneName:'底盘件区域',
            zoneList:[],
            page: 0,
            thispage: 0,
            data1: 0,
            data2: 0,
            data3: 0,
            data4: 0
        };
    },
    filters: {
        formatDateTime(value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? '0' + MM : MM;
            let d = date.getDate();
            d = d < 10 ? '0' + d : d;
            let h = date.getHours();
            h = h < 10 ? '0' + h : h;
            let m = date.getMinutes();
            m = m < 10 ? '0' + m : m;
            let s = date.getSeconds();
            s = s < 10 ? '0' + s : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
    },
    mounted() {
        let that = this;
        let zone = this.$util.getLocalStorage('zoneScreen'+this.userInfo.EmployeeId);
        if(zone){
            that.zoneId = zone.Id;
            that.zoneName = zone.Name
        }
        that.getZoneList();
        const table = this.$refs.msgTable;
        const divData = table.bodyWrapper;
        that.timer = setInterval(() => {
            that.thispage++;
            divData.scrollTop += 800;
            //if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
            if (that.thispage > that.page) {
                that.thispage = 0;
                divData.scrollTop = 0;
            }
        }, 5000);
        that.currentTime = setInterval(() => {
            that.date = new Date();
        }, 1000);
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
        if (this.currentTime) clearInterval(this.currentTime);
        if (this.timeOut) window.clearTimeout(this.timeOut);
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            return 'bgC';
        },
        getTableData() {
            let that = this;
            // that.round++;
            if (that.timeOut) {
                window.clearTimeout(that.timeOut);
            }
            return new Promise(resolve => {
                that.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetEntpZoneOrderOpLogData?ZoneId=' + that.zoneId,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data.DataList;
                        if (data) {
                            that.data4 = res.data.DeleverCount;
                            that.page = Math.ceil(res.count / 10.0);
                            let tdata = that.tableData;
                            let isNew = false;
                            data.forEach(item => {
                                let sameData = tdata.find(e => e.OrderCode == item.OrderCode);
                                if (!sameData) {
                                    isNew = true;
                                    return;
                                }
                            });
                            that.tableData = data;

                            that.data1 = that.tableData.filter(x => x.OperType == '待备货').length;
                            that.data2 = that.tableData.filter(x => x.OperType == '待打包').length;
                            that.data3 = that.tableData.filter(x => x.OperType == '等待发货').length;

                            if (isNew) that.aplayAudio(that.newOrderAudio);
                        }
                    })
                    .finally(() => {
                        resolve();
                    });
            });
        },
        getZoneList() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetZoneDataList',
                    data: {
                        WarehouseId: ""
                    }
                })
                .then(res => {
                    that.zoneList = res.data;
                    if(that.zoneId == '' && that.zoneList.length > 0){
                        that.zoneId = that.zoneList[0].Id;
                        that.zoneName = that.zoneList[0].Name;
                    }
                    that.starTimer();
                });
        },
        zoneChange(value){
            var zone = "";
            if(value){
                zone = this.zoneList.find(x=>x.Id == value)
                this.zoneId = zone.Id;
                this.zoneName = zone.Name;
            }else{
                this.zoneId = "";
                this.zoneName = "";
            }
            this.$util.setLocalStorage('zoneScreen' + this.userInfo.EmployeeId,zone);
            this.starTimer();
        },
        starTimer() {
            this.getTableData().then(data => {
                this.requestAF(this.starTimer);
            });
        },
        requestAF(callback) {
            this.timeOut = window.setTimeout(callback, 10000);
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
                this.$refs.audio.play();
            });
        }
    }
};
</script>
<style lang="less" scoped>
.screen-content {
    width: 100%;
    height: 100%;
    background: #252a2f;
}
/deep/ .el-input__inner{
    width: 240px;
    font-size: 30px;
    font-weight: 700;
    color: #ccff66 !important;
    border-color: #252a2f !important;
    background-color: #252a2f !important;
}
.screen-content .header {
    height: 120px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 20px;
    margin-bottom: 40px;

    .title {
        font-size: 76px;
        font-weight: 700;
        color: rgb(3, 194, 245);
        margin-left: 80px;
        width: 800px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .info {
        margin-left: 20px;
        font-size: 30px;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.952);
    }
    .otherdatas {
        display: flex;
        flex-direction: column;
        font-size: 32px;
        font-weight: 650;
        color: #ccff66;
        margin-right: 30px;

        .otheritems1 {
            display: flex;
            flex-direction: row;
            margin-bottom: 20px;

            .item1 {
                width: 190px;
                margin-right: 20px;
            }
        }
        .otheritems2 {
            display: flex;
            flex-direction: row;

            .item1 {
                width: 190px;
                margin-right: 20px;
            }
        }
    }
}

@media screen and (max-width: 1760px) {
    .screen-content .header {
        height: 100px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 20px;
        margin-bottom: 40px;

        .title {
            font-size: 70px;
            font-weight: 700;
            color: rgb(3, 194, 245);
            margin-left: 30px;
        }
        .otherdatas {
            display: flex;
            flex-direction: column;
            font-size: 28px;
            font-weight: 650;
            color: #ccff66;
            margin-right: 30px;

            .otheritems1 {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
            .otheritems2 {
                display: flex;
                flex-direction: row;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    .screen-content .header {
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 20px;
        margin-bottom: 40px;

        .title {
            font-size: 60px;
            font-weight: 700;
            color: rgb(3, 194, 245);
            margin-left: 20px;
        }
        .otherdatas {
            display: flex;
            flex-direction: column;
            font-size: 26px;
            font-weight: 650;
            color: #ccff66;
            margin-right: 30px;

            .otheritems1 {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
            .otheritems2 {
                display: flex;
                flex-direction: row;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
        }
    }
}

@media screen and (max-width: 1380px) {
    .screen-content {
        width: 1380px;
        height: 100%;
        background: #252a2f;
    }
    .screen-content .header {
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 20px;
        margin-bottom: 40px;

        .title {
            font-size: 60px;
            font-weight: 700;
            color: rgb(3, 194, 245);
            margin-left: 20px;
        }
        .otherdatas {
            display: flex;
            flex-direction: column;
            font-size: 26px;
            font-weight: 650;
            color: #ccff66;
            margin-right: 30px;

            .otheritems1 {
                display: flex;
                flex-direction: row;
                margin-bottom: 10px;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
            .otheritems2 {
                display: flex;
                flex-direction: row;

                .item1 {
                    width: 190px;
                    margin-right: 20px;
                }
            }
        }
    }
}

.active1 {
    color: rgb(244, 67, 54);
}
.active2 {
    color: #ff0097;
}
.active3 {
    color: rgb(139, 195, 74);
}
.active4 {
    color: #0dbdae;
}
.active5 {
    color: rgb(255, 193, 7);
}
</style>
<style lang="less">
.screen-content .el-table {
    color: #252a2f;
    background: #252a2f;

    .el-table__body-wrapper::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
    .cell {
        line-height: 40px;
        color: #fff !important;
    }
    td.el-table__cell div {
        color: #fff !important;
    }
    .bgC {
        background: #252a2f;
    }
}
</style>
